import React from "react";
import { GuardsService } from "src/services/guards/guards.service";
import { CommonService } from "src/services/common/common.service";
import { useTranslation } from "react-i18next";
import { Hub } from "aws-amplify";

export const LoginRedirectComponent = () => {
  const guardsService: GuardsService = new GuardsService();
  const commonService: CommonService = new CommonService();
  const [t] = useTranslation();

  async function init () {
    commonService.setTitle(t('login'));
    await guardsService.isNotAuthorized();
  }

  Hub.listen('auth', (data)=>{
    init();
  });

  return (
    <></>
  );
};
